document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(
    "h1.text-heading-6.sm\\:text-heading-5.uppercase.font-heading.mb-4.mt-7.sm\\:mt-8"
  );
  console.log("elementToMove", elementToMove);
  const insertAfterElement = document.querySelector(
    ".teeinblue-enabled .tee-product-price"
  );
  if (elementToMove && insertAfterElement && insertAfterElement.parentNode) {
    insertAfterElement.parentNode.insertBefore(
      elementToMove,
      insertAfterElement
    );
  }
});
